module.exports = __webpack_public_path__ + "static/banner-cb5ebbd25e1172d78c260d4aef8f890e.png";